import React, { useState, useEffect } from "react";
import './layout.css'
import Sidebar from "../Sidebar";
import { useLocation, matchPath } from "react-router-dom";
import CourseChapters from "../CourseChapters/CourseChapters";


const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [reSize, setResize] = useState(false);
    const location = useLocation()
    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    const isLessonPage = matchPath(
        "/student/courses/:enrollmentId/:chapterId/:order",
        location.pathname
    );

    const quizPage = matchPath(
        "/student/courses/quiz/:enrollmentId/:chapterId",
        location.pathname
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 550) {
                setResize(false);
            } else {
                setResize(true);
            }
        };

        handleResize(); // check on mount

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="layout">

           {!isLessonPage && reSize && <Sidebar isSidebarOpen={isSidebarOpen} />}
           {!reSize && <Sidebar isLessonPage={isLessonPage} isSidebarOpen={isSidebarOpen} />}
           {!quizPage && isLessonPage && reSize &&(<CourseChapters />)}

            <main className="content">
                {children}
            </main>
        </div>
    );
};

export default Layout;
